<template>
  <div
    v-bind:class="[$parent.isBreakpoint('xs') ? 'pl-5 pr-5' : '', $parent.isBreakpoint('sm') ? 'pl-3 pr-3' : '', $parent.isBreakpointMin('md') ? 'pl-1 pr-1' : '']">
    <v-card color="black" class="rond white--text" v-bind:class="$parent.blueBorder"
      :hover="connected && !heatingInProgress && ready && mode != '3'"
      v-on="connected && !heatingInProgress && ready && mode != '3' ? { click: () => editDialog = true } : {}">
      <!-- Widget timer -->
      <v-responsive :aspect-ratio="1 / 1">
        <v-card-text>
          <div class="paco_typo"
            v-bind:class="[{ 'paco_rouge_pure--text': timer > 0, 'white--text': !heatingInProgress }, $parent.fontSize]">
            {{ durationHuman }}</div>
          <div v-bind:class="$parent.isSmall ? 'mt-1 mb-1' : 'mt-2 mb-2'">
            <div class="main_value_container paco_typo" v-bind:class="$parent.fontSize">{{ timerHuman }}</div>
          </div>
          <div v-bind:class="$parent.isSmall ? 'mt-2' : 'mt-5'">
            <v-icon color="white" :small="$parent.isSmall" :large="$parent.isLarge">fa-clock</v-icon>
          </div>
          <!-- <span class="display-1">{{ totalHuman }}</span> -->
        </v-card-text>
      </v-responsive>

      <!-- Dialogue d'édition -->
      <v-dialog v-model="editDialog" persistent max-width="320px" @keydown.esc="cancel()">
        <v-card>
          <v-card-text v-if="!loading">
            <v-select label="Heures" :items="hourList" v-model="hourValue" menu-props="auto"></v-select>
            <v-select label="Minutes" :items="minuteList" v-model="minuteValue" menu-props="auto"></v-select>
          </v-card-text>
          <v-card-text v-else class="text-xs-center">
            <v-progress-circular color="primary" indeterminate></v-progress-circular>
          </v-card-text>

          <v-card-actions>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-btn color="black" flat large block @click="cancel()">{{ $t('global.cancel') }}</v-btn>
              </v-flex>
              <v-flex xs12 sm6>
                <v-btn color="green darken-1" flat large block @click="save()">{{ $t('global.save') }}</v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
import moment from "moment";
import momentDurationFormatSetup from "moment-duration-format";
momentDurationFormatSetup(moment);

const MINUTE_MAX = 999;

export default {
  data: () => ({
    loading: false,
    editDialog: false,
    hourValue: 0,
    minuteValue: 0,
    hourFormat: "24hr" // ampm
  }),
  computed: {
    connected() {
      return this.$store.state.connected;
    },
    ovenData() {
      return this.$store.state.ovenData;
    },
    working() {
      return this.ovenData.working;
    },
    // mode
    mode() {
      return this.ovenData.mode;
    },
    // chauffe en cours (boolean)
    heatingInProgress() {
      if (this.working == "1") {
        return true;
      }
      return false;
    },
    // en veille ou non
    state() {
      return this.ovenData.state;
    },
    // veillle ou non (boolean)
    ready() {
      if (this.state == "1") {
        return true;
      } else {
        return false;
      }
    },
    timer() {
      return this.ovenData.timer;
    },
    timerHuman() {
      if (this.timer == "?") {
        return this.timer;
      }
      return this.minutesToHumanHour(this.timer);
    },
    total() {
      return this.ovenData.total;
    },
    totalHuman() {
      if (this.total == "?") {
        return this.total;
      }
      return this.minutesToHumanHour(this.total);
    },
    duration() {
      return this.ovenData.duration;
    },
    durationHuman() {
      if (this.duration == "?") {
        return this.duration;
      }
      return this.minutesToHumanHour(this.duration);
    },
    hourList() {
      var arr = [];
      for (var i = 0; i <= 99; i++) {
        arr.push(i);
      }
      return arr;
    },
    minuteList() {
      var arr = [];
      for (var i = 0; i <= 50; i += 10) {
        arr.push(i);
      }
      return arr;
    },
    bak_minuteList() {
      var minList = [];
      for (var i = 0; i <= MINUTE_MAX; i++) {
        minList.push(i + "");
      }
      return minList;
    },
    // nombre de minute résultante
    durationValue() {
      return this.hourValue * 60 + this.minuteValue;
    }
  },
  watch: {
    duration() {
      this.durationToHourMinute();
    }
  },
  methods: {
    durationToHourMinute() {
      var d = Number(this.duration);
      this.hourValue = Math.floor(d / 60);
      this.minuteValue = d % 60;
    },
    cancel() {
      this.editDialog = false;
      this.durationToHourMinute();
    },
    // enregistre la nouvelle valeur d'heure
    save() {
      // barre de chargement
      // TODO

      // requete
      this.$store
        .dispatch("pushTime", this.durationValue + "")
        .then(() => {
          this.$store.commit("setDuration", this.durationValue + "");
        })
        .catch(err => { });

      // fermeture de la dialog
      this.editDialog = false;
    },
    minutesToHumanHour(value) {
      if (value == null) {
        return "";
      }
      if (value < 0) {
        return "";
      }

      var duration = moment.duration(Number(value), "minutes");
      return duration.format("hh:mm", { trim: false });
    }
  },
  mounted() { }
};
</script>

<style>

</style>
